import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CodeInputWrapper, CustomCodeIput } from './styles';
import { useInput } from './useInput';
const CodeInput = forwardRef(({ type, onChange, onChangeText, disabled, testId, ...rest }, ref) => {
    const { combinedRef, handleChange } = useInput({
        ref,
        disabled,
        onChange,
        onChangeText,
    });
    return (_jsx(CodeInputWrapper, { children: _jsx(CustomCodeIput, { type: type, "data-cy": testId, "data-testid": testId, ref: combinedRef, onChange: handleChange, ...rest }) }));
});
CodeInput.displayName = 'CodeInput';
export default CodeInput;
//# sourceMappingURL=CodeInput.js.map